import React from 'react';
import { useSelector } from 'react-redux';
import mpesa from '../../assets/mpesa.png';
import _ from 'lodash';
import icons from '../../utils/icons.json';
import { AnimatePresence, motion } from 'framer-motion';
import useScrollTop from '../../hooks/useScrollTop';
import { Link, useLocation } from 'react-router-dom';
import { SpeedDial, SpeedDialAction, SpeedDialIcon } from '@mui/material';
import { Facebook, Instagram, Mail, Twitter, WhatsApp } from '@mui/icons-material';

const variants = {
	initial: {
		scale: 0,
	},
	animate: {
		scale: 1,
		transition: {
			duration: 0.3,
		},
	},
	exit: {
		scale: 0,
		transition: {
			duration: 0.3,
		},
	},
};

function Footer() {
	const webSettings = useSelector((state) => state.webSettings.data);
	const { top } = useScrollTop(window);
	const location = useLocation()
	const path = location?.pathname?.split("/")[1];


	const actions = [
		{ icon: <WhatsApp onClick={() => window.open(`https://wa.me/${webSettings.TELEPHONES_LINK.replace(/\s/g, '')}`)} />, name: 'Whatsapp' },
		{ icon: <Twitter onClick={() => window.open(`${webSettings.TWITTER_LINK}`)} />, name: 'Twitter' },
		{ icon: <Instagram onClick={() => window.open(`${webSettings.INSTAGRAM_LINK}`)} />, name: 'Instagram' },
		{ icon: <Mail onClick={() => window.open(`mailto:${webSettings.EMAIL_LINK}`)} />, name: 'Email' },
		{ icon: <Facebook onClick={() => window.open(`${webSettings.FACEBOOK_LINK}`)} />, name: 'Facebook' },
	];

	return (
		path !== 'supportdashboard' && <footer>
			<div className="inner">
				<div className="links">
					<div className="main-section">
						<div className="sub-section">
							<h3>Contact Us</h3>
							<a href="#">Call us 24/7</a>
							<a href={`call:${webSettings.TELEPHONES_LINK}`}>{webSettings.TELEPHONES_LINK}</a>
							<a href="#" dangerouslySetInnerHTML={{ __html: _.replace(webSettings.ADDRESS_LINK, ',', ',<br />') }}></a>
							<a href={`mailto:${webSettings.EMAIL_LINK}`}>{webSettings.EMAIL_LINK}</a>
						</div>
						<div className="sub-section">
							<h3>Follow Us</h3>
							<a href={webSettings.FACEBOOK_LINK || '#'} target={webSettings.FACEBOOK_LINK ? '_blank' : '_self'}>
								<img src="" alt="" />
								Facebook
							</a>
							<a href={webSettings.TWITTER_LINK || '#'} target={webSettings.TWITTER_LINK ? '_blank' : '_self'}>
								<img src="" alt="" />
								Twitter
							</a>
							<a href={webSettings.YOUTUBE_LINK || '#'} target={webSettings.YOUTUBE_LINK ? '_blank' : '_self'}>
								<img src="" alt="" />
								Youtube
							</a>
							<a href={webSettings.INSTAGRAM_LINK || '#'} target={webSettings.INSTAGRAM_LINK ? '_blank' : '_self'}>
								<img src="" alt="" />
								Instagram
							</a>
						</div>
					</div>
					<div className="main-section"></div>
					<div className="main-section">
						<div className="sub-section">
							<h3>Customer Service</h3>
							<a href="/help#ordering">Ordering</a>
							<a href="/help#payments">Payments</a>
							<a href="/help#shipping">Shipping &amp; Delivery</a>
							<a href="/help#returns">Returns</a>
						</div>
						<div className="sub-section">
							<h3>About Us</h3>
							<Link to="/about">Our Company</Link>
							{/* <a href='#'>Our Team</a> */}
							{/* <a href='#'>Our Customers</a> */}
						</div>
					</div>
				</div>
				<div className="sub-footer flex">
					<p className="copyright">&copy; 2021 {''} All Rights Reserved</p>
					<section className="flex">
						<p>We accept payment from</p>
						<img src={mpesa} alt="" />
					</section>
				</div>
			</div>
			<AnimatePresence>
				{top > 600 && (
					<motion.button
						variants={variants}
						initial="initial"
						animate="animate"
						exit={variants.exit}
						onClick={() => window.scroll({ top: 0, behavior: 'smooth' })}
						className="action-btn scroller"
						dangerouslySetInnerHTML={{ __html: icons.angle_up }}
						title="Scroll to top"
					></motion.button>
				)}
			</AnimatePresence>

			{/* <a
				 href="https://api.whatsapp.com/send?phone=254708727272"
				target="_blank"
				className="action-btn whatsapp"
				dangerouslySetInnerHTML={{ __html: icons.whatsapp }}
				title="WhatsApp Customer Care"
			></a> */}
			<SpeedDial
				ariaLabel="SpeedDial basic example"
				sx={{ position: 'fixed', bottom: 2, right: "2.3%" }}
				icon={<SpeedDialIcon />}
			>
				{actions.map((action) => (
					<SpeedDialAction
						color='warning'
						key={action.name}
						icon={action.icon}
						tooltipTitle={action.name}
					/>
				))}
			</SpeedDial>
		</footer>
	);
}

export default React.memo(Footer);
